export const environment = {
  production: false,
  apiUrl: '/api',
  portalUrl: 'https://hom.eservicos.sefaz.ms.gov.br'
};